function requireEnv(name, value) {
  if (value === undefined || value === null || String(value).trim() === "") {
    throw new Error(
      `[meetyoo-internal] Missing required env var ${name}. ` +
        `This app is built with Vite; env vars are baked in at build time. ` +
        `If you set vars inline, ensure your line-continuation backslashes have no trailing spaces.`
    );
  }
  return String(value);
}

export const OAUTH_SERVER = requireEnv("REACT_APP_OAUTH_SERVER", import.meta.env.REACT_APP_OAUTH_SERVER);
export const RESPONSE_TYPE = "code";
export const CLIENT_ID = import.meta.env.REACT_APP_CLIENT_ID
  ? import.meta.env.REACT_APP_CLIENT_ID
  : "passcode-manager@service.meetyoo.de";
export const CLIENT_SECRET = import.meta.env.REACT_APP_CLIENT_SECRET;
export const REDIRECT_URL = requireEnv("REACT_APP_REDIRECT_URL", import.meta.env.REACT_APP_REDIRECT_URL);
export const REFRESH_TOKEN = "refresh_token";
export const GRANT_TYPE = "authorization_code";
export const SCOPE = requireEnv("REACT_APP_SCOPE", import.meta.env.REACT_APP_SCOPE);

const authorizationUrl = new URL(OAUTH_SERVER);
if (!authorizationUrl.pathname.endsWith("/")) {
  authorizationUrl.pathname = `${authorizationUrl.pathname}/`;
}
authorizationUrl.pathname = `${authorizationUrl.pathname}auth`;
authorizationUrl.searchParams.set("response_type", RESPONSE_TYPE);
authorizationUrl.searchParams.set("scope", SCOPE);
authorizationUrl.searchParams.set("client_id", CLIENT_ID);
authorizationUrl.searchParams.set("redirect_uri", REDIRECT_URL);
export const AUTHORIZATION_URL = authorizationUrl.toString();

export const PASSCODE_SERVER = import.meta.env.REACT_APP_PASSCODE_SERVER;
export const BILLING_SERVER = import.meta.env.REACT_APP_BILLING_SERVER;
export const EVENTMGT_SERVER = import.meta.env.REACT_APP_EVENTMGT_SERVER;
export const EVENTMGT_WEBSOCKET = import.meta.env.REACT_APP_EVENTMGT_WEBSOCKET;
export const EVENTMGT_ORDER_SERVER = import.meta.env.REACT_APP_EVENTMGT_ORDER_SERVER;
export const EVENTMGT_REFRESH_TIME = import.meta.env.REACT_APP_EVENTMGT_REFRESH_TIME
  ? import.meta.env.REACT_APP_EVENTMGT_REFRESH_TIME
  : 10000;

export const NAV_COMPANYS = [{key: "meetyoo_conferencing_GmbH", text: "meetyoo conferencing GmbH"}, {key: "MEETYOO_Inc", text: "MEETYOO Inc."}];
